import { env } from './env';

const DEFAULT_SITE_URL = 'https://tecniq.com.au';
const DEFAULT_APP_DEEP_LINK = 'tecniq://auth-callback';

function trimTrailingSlash(value) {
  return value.replace(/\/+$/, '');
}

export function sanitizeNextPath(nextPath) {
  if (!nextPath || typeof nextPath !== 'string') {
    return '/';
  }

  if (!nextPath.startsWith('/') || nextPath.startsWith('//')) {
    return '/';
  }

  return nextPath;
}

export function getSiteOrigin() {
  const configuredOrigin = env.SITE_URL;

  if (configuredOrigin) {
    return trimTrailingSlash(configuredOrigin);
  }

  if (typeof window !== 'undefined' && window.location?.origin) {
    return trimTrailingSlash(window.location.origin);
  }

  return DEFAULT_SITE_URL;
}

export function getAppDeepLink() {
  return env.APP_DEEP_LINK || DEFAULT_APP_DEEP_LINK;
}

export function buildAppOpenUrl() {
  return getAppDeepLink();
}

export function buildEmailConfirmationUrl() {
  return `${getSiteOrigin()}/auth/confirm`;
}

export function buildResultRoute(pathname, nextPath) {
  const safeNext = sanitizeNextPath(nextPath);
  const searchParams = new URLSearchParams();

  if (safeNext !== '/') {
    searchParams.set('next', safeNext);
  }

  const queryString = searchParams.toString();
  return queryString ? `${pathname}?${queryString}` : pathname;
}

export function getSafeAuthType(type) {
  if (typeof type !== 'string') {
    return '';
  }

  const normalizedType = type.trim().toLowerCase();
  const supportedTypes = new Set(['email', 'signup']);

  return supportedTypes.has(normalizedType) ? normalizedType : '';
}
